document.addEventListener('DOMContentLoaded', () => {
  const initCustomVideos = ({
    moduleSelector,
    videoSelector,
    playPauseBtnSelector,
    playIconSelector,
    pauseIconSelector,
    progressContainerSelector,
    progressBarSelector,
    muteBtnSelector,
    muteIconSelector,
    unmuteIconSelector,
  }) => {
    const modules = document.querySelectorAll(moduleSelector);

    modules.forEach((module) => {
      const video = module.querySelector(videoSelector);
      const btn = module.querySelector(playPauseBtnSelector);
      const playIcon = module.querySelector(playIconSelector);
      const pauseIcon = module.querySelector(pauseIconSelector);
      const progressContainer = module.querySelector(progressContainerSelector);
      const progress = module.querySelector(progressBarSelector);
      const muteButton = module.querySelector(muteBtnSelector);
      const muteIcon = module.querySelector(muteIconSelector);
      const unmuteIcon = module.querySelector(unmuteIconSelector);

      if (!video) return;

      // Mute/unmute
      if (muteButton && muteIcon && unmuteIcon) {
        muteButton.addEventListener('click', () => {
          video.muted = !video.muted;
          muteIcon.style.display = video.muted ? 'block' : 'none';
          unmuteIcon.style.display = video.muted ? 'none' : 'block';
        });
      }

      // Play/pause
      if (btn && playIcon && pauseIcon) {
        btn.addEventListener('click', () => {
          video.paused ? video.play() : video.pause();
        });

        video.addEventListener('pause', () => {
          playIcon.classList.remove('hidden');
          pauseIcon.classList.add('hidden');
          btn.classList.remove('opacity-0');
          btn.classList.add('opacity-100');
        });

        video.addEventListener('play', () => {
          pauseIcon.classList.remove('hidden');
          playIcon.classList.add('hidden');
          btn.classList.add('opacity-0');
          btn.classList.remove('opacity-100');
        });

        module.addEventListener('mouseenter', () => {
          if (!video.paused) {
            btn.classList.remove('opacity-0');
            btn.classList.add('opacity-100');
          }
        });

        module.addEventListener('mouseleave', () => {
          if (!video.paused) {
            btn.classList.add('opacity-0');
            btn.classList.remove('opacity-100');
          }
        });
      }

      // Seek on progress bar click
      if (progressContainer) {
        progressContainer.addEventListener('click', (e) => {
          const rect = progressContainer.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          video.currentTime = (clickX / rect.width) * video.duration;
        });
      }

      // Update progress bar
      if (progress) {
        video.addEventListener('timeupdate', () => {
          const percentage = (video.currentTime / video.duration) * 100;
          progress.style.width = `${percentage}%`;
        });
      }
    });
  };

  // Desktop video
  initCustomVideos({
    moduleSelector: '.media-module-container',
    videoSelector: '.customVideoDesktop',
    playPauseBtnSelector: '.customPlayPauseBtn',
    playIconSelector: '.customPlayIcon',
    pauseIconSelector: '.customPauseIcon',
    progressContainerSelector: '.customProgressContainer',
    progressBarSelector: '.customProgress',
    muteBtnSelector: '.muteButton',
    muteIconSelector: '.muteIcon',
    unmuteIconSelector: '.unmuteIcon',
  });

  // Mobile video
  initCustomVideos({
    moduleSelector: '.media-module-container',
    videoSelector: '.customVideoMobile',
    playPauseBtnSelector: '.customPlayPauseBtnMobile',
    playIconSelector: '.customPlayIconMobile',
    pauseIconSelector: '.customPauseIconMobile',
    progressContainerSelector: '.customProgressContainerMobile',
    progressBarSelector: '.customProgressMobile',
    muteBtnSelector: '.muteButtonMobile',
    muteIconSelector: '.muteIconMobile',
    unmuteIconSelector: '.unmuteIconMobile',
  });
});
